import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonHelper } from './../../../helper/common-helper'

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  
  aboutSection1 = '';
  aboutSection2 = '';
  aboutOurPoser = '';
  AboutUsYoutubeID = '';
  constructor(private CommonHelper:CommonHelper, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loadText();
    this.CommonHelper.retrieveMappedCommonObjectObject().subscribe((t) =>{
      this.loadText()
     })

  }

  loadText() {
    this.aboutSection1 = CommonHelper.CommonDetails.AboutSection1;
    this.aboutSection2 = CommonHelper.CommonDetails.AboutSection2;
    this.aboutOurPoser = CommonHelper.CommonDetails.AboutOurPoser;  
    this.AboutUsYoutubeID = CommonHelper.CommonDetails.AboutUsYoutubeID;  
  }
  
  securityByPass(url: any){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
